module.exports = __webpack_public_path__ + "img/Ocean+-data-viewer-logo.aafffc86.svg";